<template>
    <textarea :class="_class" v-bind="$attrs" v-bind:value="value"  v-on="listeners"></textarea>
</template>

<script>
export default {
    props: {
        is_last: {
            type: Boolean
        },
        size: {
            type: String
        },
        value: {
            default: null
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    computed: {
        _class: function() {
            let _class = []

            _class.push('form-control')

            if(this.is_last === true) {
                _class.push('form-control-last')
            }

            if(this.size) {
                _class.push('form-control-'+this.size)
            }

            return _class
        },
        listeners: function () {
            var vm = this
            return Object.assign({},
                this.$listeners,
                {
                    change: function (event) {
                        vm.$emit('change', event.target.value)
                    }
                }
            )
        }
    },
}
</script>